import { TooltipCode } from 'areas/shared/consts';

const IncorporationArticles = { 
    code: "IncorporationArticles", 
    visible: true,
    description: "Articles of Organization (Amendments, if applicable)",
    tooltipCode: TooltipCode.ARTICLE.ORGARTICLEUPLOAD
};

const IncorporationCertificate = { 
    code: "IncorporationCertificate", 
    visible: true,
    description: "Certificate of Organization",
    tooltipCode: TooltipCode.ARTICLE.ORGCERTIFICATEUPLOAD
};

const CorporateByLaws = { 
    code: "CorporateByLaws", 
    visible: false,
    description: ""
};

const ForeignEntityCertificate = {
    code: "ForeignEntityCertificate", 
    visible: true,
    description: "Foreign Entity Certificate",
    tooltipCode: TooltipCode.ARTICLE.FOREIGNENTCERUPLOAD
};

const OfficersElectedMinutes = { 
    code: "OfficersElectedMinutes", 
    visible: true,
    description: "Minutes of the last meeting where members were identified and elected",
    tooltipCode: TooltipCode.ARTICLE.MINLASTMEETINGMEMBERSUPLOAD
};

const FirstBoardMeetingMinutes = { 
    code: "FirstBoardMeetingMinutes", 
    visible: true,
    description: "Minutes of 1st Member's Meeting (If business is less than 2 years old)",
    tooltipCode: TooltipCode.ARTICLE.MINFIRSTMEMBERMEETINGUPLOAD
};

const MostRecentMeetingMinutes = { 
    code: "MostRecentMeetingMinutes", 
    visible: true,
    description: "Minutes of Last Member's Meeting",
    tooltipCode: TooltipCode.ARTICLE.MINLASTMEMBERMEETINGUPLOAD
};

const CapitalContributionProof = { 
    code: "CapitalContributionProof", 
    visible: true,
    description: "Proof of Capital Investment by majority owner at time of company start or owner's acquisition",
    tooltipCode: TooltipCode.ARTICLE.CAPINVESTPROOF
};

const StockPurchaseProof = { 
    code: "StockPurchaseProof", 
    visible: true,
    description: "Proof of Unit Purchase",
    tooltipCode: TooltipCode.ARTICLE.UNITPURCHASEPROOFUPLOAD
};

const CorporateStockCertificates = { 
    code: "CorporateStockCertificates", 
    visible: true,
    description: "Corporate Member/Unit Certificates",
    tooltipCode: TooltipCode.ARTICLE.CORPMEMBERUNITCERTUPLOAD
};

const CorporateStockLedger = {
    code: "CorporateStockLedger",
    visible: true,
    description: "Current LLC Member's Unit Ledger Book",
    tooltipCode: TooltipCode.ARTICLE.CURRENTUNITLEDBOOKUPLOAD
};

const OperationalAgreement = {
    code: "OperationalAgreement",
    visible: true,
    description: "Operational and/or Organizational Agreement",
    tooltipCode: TooltipCode.ARTICLE.OPERATIONALAGRUPLOAD
};

const BuyOutRights = {
    code: "BuyOutRights",
    visible: false,
    description: ""
};

const LimitedPartnershipCertificate = {
    code: "LimitedPartnershipCertificate",
    visible: false,
    description: ""
};

const LimitedPartnershipDocuments = {
    code: "LimitedPartnershipDocuments",
    visible: false,
    description: ""
};

const PartnershipAgreements = {
    code: "PartnershipAgreements",
    visible: false,
    description: ""
};

const ProfitSharing = {
    code: "ProfitSharing",
    visible: false,
    description: ""
};

const ThirdPartyAgreements = {
    code: "ThirdPartyAgreements",
    visible: false,
    description: ""
};

export default {
    IncorporationArticles,
    IncorporationCertificate,
    CorporateByLaws,
    ForeignEntityCertificate,
    OfficersElectedMinutes,
    FirstBoardMeetingMinutes,
    MostRecentMeetingMinutes,
    CapitalContributionProof,
    StockPurchaseProof,
    CorporateStockCertificates,
    CorporateStockLedger,
    OperationalAgreement,
    BuyOutRights,
    LimitedPartnershipCertificate,
    LimitedPartnershipDocuments,
    PartnershipAgreements,
    ProfitSharing,
    ThirdPartyAgreements
};


// WEBPACK FOOTER //
// ./src/areas/certification/steps/articles/UploadsConfig/LlcConfig.js